/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { createContext, useContext } from "react";
import { CommandsService } from "../../commands/CommandsService";
import { KeyBindingService } from "../../keyBinding/KeyBindingService";
import { MenuService } from "../../menu/MenuService";
import { ResourceService } from "../../resources/ResourceService";
import { RuntimeService } from "../../runtime/RuntimeService";
import { AbilityService } from "../../ability/AbilityService";
import { IAppInfo } from "../../common/AppInfo";
import { IAccount } from "@adapptio/lib-core";
import { ToastService } from "../../toasts/ToastService";
// import { MEDIA_RESOLUTIONS_string } from "@adapptio/lib-blueprint";
import { StateService } from "../../state/StateService";

/**
 * Editor Main Context
 */
export interface IEditorMainContext {
	rootEl: React.MutableRefObject<HTMLElement>;
	appInfo: IAppInfo;
	userInfo: IAccount;
	abilityService: AbilityService;
	menuService: MenuService;
	commandsService: CommandsService;
	keyBindingService: KeyBindingService;
	runtimeService: RuntimeService;
	resourceService: ResourceService;
	stateService: StateService;
	toastService: ToastService;
}

export const EditorMainContext = createContext<IEditorMainContext>(null);

export function useEditorMainContext(): IEditorMainContext {
	return useContext(EditorMainContext);
}
